import { motion, useScroll } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-[3px] bg-ember origin-left z-[80]"
      style={{ scaleX: scrollYProgress }}
      data-testid="scroll-progress"
    />
  );
};
